import { render, staticRenderFns } from "./UcContractStatusBadge.yaml?vue&type=template&id=38f729bc&component"
import script from "./UcContractStatusBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractStatusBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports